<template>
  <div class="product-page__row row">
    <div class="col-xl-10">
      <div class="product-page__wrapper">
        <div class="product-page__order">
          <span class="product-page__price">{{selected ? parseInt(selected.pivot.price).toLocaleString(): parseInt(item.price).toLocaleString()}} UAH</span>
          <div class="product-page__order-block">
            <catalog-add-button/>
            <favorite-product-button :id="item.id"/>
          </div>
        </div>
        <div class="product-page__guarantee">
          <span class="guarantee-icon badge-icon"></span>
          <div class="product-page__guarantee-body">
            <span class="product-page__guarantee-text-1">3 years</span>
            <p class="product-page__guarantee-text-2">Warranty</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CatalogAddButton from './CatalogAddButton'
import { mapGetters } from 'vuex'

export default {
  components: { CatalogAddButton },
  name: 'ProductOrderTotal',
  computed: {
    ...mapGetters('shop_card', ['item', 'selected']),
  },
  mounted () {
    console.log(this.selected)
  }
}
</script>

<style scoped>

</style>
